import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import type {
  OperationCategoryChange,
  OperationCategoryChanged,
} from '../../model/bank-operation.js';
import { changeOperationCategory } from '../requests/change-operation-category.js';
import { refreshAfterCategoryChange } from './bank-transaction-cache.js';

export const useChangeOperationCategoryMutation = (): UseMutationResult<
  OperationCategoryChanged,
  Error,
  OperationCategoryChange
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeOperationCategory,
    onSuccess: () => refreshAfterCategoryChange(queryClient),
  });
};
